import GLightbox from 'glightbox';

var lightbox = GLightbox({
    selector: ".wp-block-gallery a",
    skin: "clean",
    closeButton: true,
    height: "auto",
  });
  console.log(lightbox)